import SectorsList from '../layout/pages/SectorsCards.vue'
import { createStore } from 'vuex'

export const dataEvent = createStore({
  state: () => {
    return {
      allEvents: [],
      allFighters: [],
      events: {
        title: null,
        description: null,
        date: null,
        location: null,
        amount: null,
        price: null,
        starts_at: null,
        ends_at: null,
        youtube_video_id: null,
        is_live: null,
        is_private: null,
        requires_payment: null,
        allows_sponsorship: null,
        banner: null,
        tag: null,

        integrantes: [],
        descAmount: null,
        descPorcent: null
      },
      selectedFighter: null,

      componentActive: SectorsList,
      backToComponent: 'SectorsList',
      pageTitle: 'SETORES',
      pageSubTitle: 'Gerencie seus sistema de emergência por setores',
      buttonActive: true,

      // component anterior
      sectors: [], // list
      sectorId: undefined,
      itemsBySector: [],
      sectorForm: {
        title: undefined,
        category: undefined,
        resum: undefined,
        banner: undefined,
        content: undefined
      },
      itensForm: {
        name: undefined,
        type: undefined,
        category: undefined,
        values: {}, // components form
        images: undefined,
        imagesName: undefined,

        description: undefined,
        check_every: undefined,
        next_check: undefined,
        th_expiration: undefined,
        validity_expiration: undefined
      },
      maintenanceForm: {
        type: undefined,
        values: {},
        checklist: [],
        carried_out_in: undefined,
        images: undefined,
        imagesName: undefined
      }
    }
  },
  getters: {
    getActiveComponent: (state) => state.componentActive,
    backToComponent: (state) => state.backToComponent,

    getTitle: (state) => state.pageTitle,
    getPageSubTitle: (state) => state.pageSubTitle,
    getIfButtonActive: (state) => state.buttonActive,
    getSectors: (state) => state.sectors,
    getItensBySector: (state) => state.itemsBySector,
    getAllEvents: (state) => state.allEvents,
    getAllFighters: (state) => state.allFighters
  },
  mutations: {
    RESET_MAINTENANCE (state) {
      state.maintenanceForm.values.motivo = undefined
      state.maintenanceForm.values.description = undefined
      state.maintenanceForm.values.description = undefined
      state.maintenanceForm.values.imagesName = undefined
      state.maintenanceForm.values.images = undefined

      state.maintenanceForm.checklist = []
      state.maintenanceForm.carried_out_in = undefined
      state.maintenanceForm.images = undefined
      state.maintenanceForm.imagesName = undefined
    },
    RESET_FORM (state) {
      state.events.title = null
      state.events.description = null
      state.events.date = null
      state.events.location = null
      state.events.amount = null
      state.events.price = null
      state.events.starts_at = null
      state.events.ends_at = null
      state.events.youtube_video_id = null
      state.events.is_live = null
      state.events.is_private = null
      state.events.requires_payment = null
      state.events.allows_sponsorship = null
      state.events.banner = null
      state.events.bannerName = null
      state.events.tag = null

      state.events.integrantes = []
      state.events.amount = null
      state.events.porcent = null
    },
    SET_COMPONENT_ACTIVE (state, value) {
      state.componentActive = value
    },
    SET_ALL_EVENTS (state, value) {
      state.allEvents = []
      state.allEvents = value
    },
    SET_ALL_FIGHTERS (state, value) {
      state.allFighters = []
      state.allFighters = value
    },
    SET_PAGE_TITLE (state, value) {
      state.pageTitle = value
    },
    SET_PAGE_SUB_TITLE (state, value) {
      state.pageSubTitle = value
    },
    SET_IF_BUTTON_ACTIVE (state, value) {
      state.buttonActive = value
    },
    SET_BACK_COMPONENT (state, value) {
      state.backToComponent = value
    },
    SET_ITENS_BY_SECTOR (state, value) {
      state.itemsBySector = []
      state.itemsBySector = value
    },
    NEW_ITEM_BY_SECTOR (state, payload) {
      state.itemsBySector.unshift(payload)
    },
    NEW_EVENT_ITEM (state, value) {
      state.allEvents.unshift(value)
    },
    SET_MAINTENANCES (state, value) {
      state.itensForm.maintenances = []
      state.itensForm.maintenances = value
    },
    SET_ITEM_TO_EDIT (state, value) {
      const data = { ...value }

      if (
        data.values != null ||
        data.values != [null] || data.values != '[null]' ||
        data.values != [[]] || data.values != '[[]]'
      ) {
        try {
          const parsed = JSON.parse(data.values)
          data.values = Array.isArray(parsed) && parsed.length > 0 ? parsed[0] : {}
        } catch (error) {
          console.error('Erro ao fazer parse do JSON:', error)
          data.values = {}
        }
      }

      // Atualiza o state
      state.itensForm = data
    },
    ADD_INTEGRANTE (state, payload) {
      if (!state.events.integrantes) {
        state.events.integrantes = []
      }
      state.events.integrantes.push(payload)
    }
  },
  actions: {
    resetForm ({ commit }) {
      commit('RESET_FORM')
    },
    setAllEvents ({ commit }, val) {
      commit('SET_ALL_EVENTS', val)
    },
    setAllFighters ({ commit }, val) {
      commit('SET_ALL_FIGHTERS', val)
    },
    setComponentActive ({ commit }, value) {
      commit('SET_COMPONENT_ACTIVE', value)
    },
    setPageTitle ({ commit }, value) {
      commit('SET_PAGE_TITLE', value)
    },
    setPageSubTitle ({ commit }, value) {
      commit('SET_PAGE_SUB_TITLE', value)
    },
    setButtonActive ({ commit }, value) {
      commit('SET_IF_BUTTON_ACTIVE', value)
    },
    setBackComponent ({ commit }, value) {
      commit('SET_BACK_COMPONENT', value)
    },
    setItemsBySector ({ commit }, value) {
      commit('SET_ITENS_BY_SECTOR', value)
    },
    addNewEventCollect ({ commit }, value) {
      commit('NEW_EVENT_ITEM', value)
    },
    newItemBySector ({ commit }, value) {
      commit('NEW_ITEM_BY_SECTOR', value)
    },
    setItemToEdit ({ commit }, value) {
      commit('SET_ITEM_TO_EDIT', value)
    },
    setMaintenances ({ commit }, value) {
      commit('SET_MAINTENANCES', value)
    },
    resetMaintenanceForm ({ commit }) {
      commit('RESET_MAINTENANCE')
    }
  }
})
